import React, { useCallback, useMemo } from 'react';
import { StyleSheet } from 'react-native';

import { Box } from '@/components/lib/components';

import { CasinoGame } from '../../hooks/use-casino-games';
import { useCarouselCardSize } from '../../hooks/use-desktop-carousel';
import { CARD_GAP } from '../../utils/constants';
import { CasinoLayoutProps } from '../../utils/utils';
import { CasinoGameCardBase } from '../CasinoGameCardBase';
import { DesktopCarousel } from './DesktopCarousel';

const VISIBLE_COLUMNS = 6;

type GamePair = [CasinoGame, CasinoGame?];

const keyExtractor = (item: GamePair, index: number) => `pair-${item[0].id}-${item[1]?.id ?? 'single'}-${index}`;

export const DoubleRowLayout = ({ data, layoutHeaderProps }: CasinoLayoutProps) => {
    const cardSize = useCarouselCardSize(VISIBLE_COLUMNS);

    const pairedData = useMemo(() => {
        const pairs: GamePair[] = [];
        for (let i = 0; i < data.length; i += 2) {
            pairs.push([data[i], data[i + 1]]);
        }
        return pairs;
    }, [data]);

    const renderItem = useCallback(
        ({ item }: { item: GamePair }) => {
            const [topGame, bottomGame] = item;

            return (
                <Box style={{ width: cardSize }}>
                    <Box style={styles.topCard}>
                        <CasinoGameCardBase
                            game={topGame}
                            cardHeight={cardSize}
                            cardWidth={cardSize}
                            imageHeight={cardSize}
                        />
                    </Box>
                    {bottomGame ? (
                        <CasinoGameCardBase
                            game={bottomGame}
                            cardHeight={cardSize}
                            cardWidth={cardSize}
                            imageHeight={cardSize}
                        />
                    ) : null}
                </Box>
            );
        },
        [cardSize]
    );

    return (
        <DesktopCarousel
            data={pairedData}
            itemWidth={cardSize}
            visibleCount={VISIBLE_COLUMNS}
            keyExtractor={keyExtractor}
            renderItem={renderItem}
            layoutHeaderProps={layoutHeaderProps}
        />
    );
};

const styles = StyleSheet.create({
    topCard: {
        marginBottom: CARD_GAP,
    },
});
